import React from 'react';
import { Outlet } from 'react-router-dom';

// En el futuro, este layout podría tener una barra de navegación secundaria
// o un menú lateral específico para las funciones de ACTSIS.
function LayoutSistemaActsis() {
    return (
        <div>
            {/* Por ejemplo, podríamos tener un encabezado específico aquí */}
            {/* <h2 className="container mt-3">Módulo: Actividades de Sistemas</h2> */}
            
            {/* Outlet renderizará la ruta hija (nuestra lista de tareas) */}
            <Outlet />
        </div>
    );
}

export default LayoutSistemaActsis;